import React, { ReactElement } from 'react';
import InstanceModeSwitch from '../InstanceModeSwitch';

export const SwitchMindestvertragslaufzeit = (props: { children: ReactElement }) => {
  return <InstanceModeSwitch enable={['bike', 'person', 'wohnen']}>{props.children}</InstanceModeSwitch>;
};
